import { Component, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { TableLazyLoadEvent, TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { DialogModule } from 'primeng/dialog';
import { ToastModule } from 'primeng/toast';
import { TagModule } from 'primeng/tag';
import { InputTextModule } from 'primeng/inputtext';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MessageService, ConfirmationService } from 'primeng/api';

import { OrderService } from '../../../../core/services/order.service';
import { Order } from '../../../../shared/models/Order';
import { PeruDatePipe } from '../../../../shared/pipes/peru-date.pipe';

@Component({
  selector: 'app-payment-verification',
  standalone: true,
  imports: [
    CommonModule, FormsModule, TableModule, ButtonModule,
    DialogModule, ToastModule, TagModule, InputTextModule, ConfirmDialogModule, PeruDatePipe
  ],
  providers: [MessageService, ConfirmationService],
  templateUrl: './payment-verification.html',
  styleUrl: './payment-verification.css',
})
export class PaymentVerification {

  orders: Order[] = [];
  loading: boolean = true;
  first = 0;
  rows = 10;
  totalRecords = 0;

  selectedOrder: Order | null = null;
  detailDialog: boolean = false;
  isProcessing: boolean = false;
  syncPaymentId: string = '';
  syncOrderId: string = '';

  constructor(
    private orderService: OrderService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef
  ) {}

  loadOrders(event?: TableLazyLoadEvent) {
    this.loading = true;
    const first = event?.first ?? this.first;
    const rows = event?.rows || this.rows;
    this.first = first || 0;
    this.rows = rows;
    const page = this.rows > 0 ? Math.floor(this.first / this.rows) : 0;
    this.orderService.getAdminOrders({
      page,
      size: this.rows,
      canal: 'WEB',
      isManualSale: false,
      vista: 'PAGOS'
    }).subscribe({
      next: (res) => {
        this.orders = res.content || [];
        this.totalRecords = res.totalElements || 0;
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        this.orders = [];
        this.totalRecords = 0;
        console.error(err);
        this.messageService.add({severity:'error', summary:'Error', detail:'No se pudieron cargar los pedidos'});
        this.cdr.detectChanges();
      }
    });
  }

  channelLabel(order: Order): string {
    if (order.paymentChannel === 'MERCADOPAGO') return 'MercadoPago';
    if (order.paymentChannel === 'MANUAL_TRANSFER') return 'Transferencia';
    return order.paymentMethod || '—';
  }

  reviewOrder(order: Order) {
    this.selectedOrder = order;
    this.syncPaymentId = order.mpPaymentId || '';
    this.syncOrderId = order.id ? String(order.id) : '';
    this.detailDialog = true;
  }

  syncMpPayment() {
    if (!this.syncPaymentId?.trim()) {
      this.messageService.add({severity:'warn', summary:'Pago MP', detail:'Ingresa el payment id de MercadoPago'});
      return;
    }
    this.isProcessing = true;
    this.orderService.syncMercadoPagoPayment(this.syncPaymentId.trim()).subscribe({
      next: () => {
        this.messageService.add({severity:'success', summary:'Sincronizado', detail:'Estado actualizado desde MercadoPago'});
        this.detailDialog = false;
        this.isProcessing = false;
        this.loadOrders();
      },
      error: (err) => {
        this.isProcessing = false;
        this.messageService.add({
          severity:'error',
          summary:'Error',
          detail: err?.error?.message || 'No se pudo sincronizar el pago'
        });
      }
    });
  }

  syncMpOrder() {
    const orderId = Number(this.syncOrderId?.trim());
    if (!orderId) {
      this.messageService.add({severity:'warn', summary:'Pago MP', detail:'Ingresa el número de pedido'});
      return;
    }
    this.isProcessing = true;
    this.orderService.syncMercadoPagoOrder(orderId).subscribe({
      next: () => {
        this.messageService.add({severity:'success', summary:'Sincronizado', detail:'Pedido actualizado desde MercadoPago'});
        this.detailDialog = false;
        this.isProcessing = false;
        this.loadOrders();
      },
      error: (err) => {
        this.isProcessing = false;
        this.messageService.add({
          severity:'error',
          summary:'Error',
          detail: err?.error?.message || 'No se pudo sincronizar el pedido'
        });
      }
    });
  }
}
